import AsyncStorage from "@react-native-async-storage/async-storage";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface InstallSourceState {
  installSource: string | null;
  setInstallSource: (source: string) => void;
}

export const useInstallSourceStore = create<InstallSourceState>()(
  persist(
    (set, get) => ({
      installSource: null,
      setInstallSource: (source) => {
        const trimmed = source?.trim();
        if (!trimmed || get().installSource != null) return;
        set({ installSource: trimmed });
      },
    }),
    {
      name: "install-source-store",
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (s) => ({ installSource: s.installSource }),
      version: 1,
    }
  )
);